import Slider from "@mui/material/Slider";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Card from "../../components/Cards/Card";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import Modal from "../../components/Modal/Modal";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";

function DashboardDesktop({ app, config }) {
  const { setSwitchOnDemand } = useQlik();
  const { container } = config.dashboard;
  const [vCrescFaturamento, setVCrescFaturamento] = useState("");
  const [selectPeriodo, setSelectPeriodo] = useState("");
  const [selectTipoSelecao, setSelectTipoSelecao] = useState("");
  const [vRanking, setVRanking] = useState(5);
  const [modalOpened, setModalOpened] = useState(false);
  const [selectedButtonIndex, setSelectedButtonIndex] = useState(-1);

  const showModal = (index) => {
    setSelectedButtonIndex(index);
    setModalOpened(true);
  };

  function closeModal() {
    setModalOpened(false);
  }

  const marks = [
    {
      value: 3,
      label: "3",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 10,
      label: "10",
    },
    {
      value: 15,
      label: "15",
    },
    {
      value: 20,
      label: "20",
    },
    {
      value: 25,
      label: "25",
    },
  ];

  const handleSliderChangeCommitted = (event, newValue) => {
    const value = parseInt(newValue, 10);
    app.variable.setNumValue("vRanking", value);
  };
  function updateSlider() {
    app.variable.getContent("vRanking", (reply) => {
      const data = parseInt(reply.qContent.qString, 10);
      if (data !== undefined) {
        setVRanking(data);
      }
    });
  }
  function valuetext(value) {
    return `${value}%`;
  }

  const initializeField = () => {
    app.variable.getContent("vCrescFaturamento", (reply) => {
      const data = reply.qContent.qString;
      setVCrescFaturamento(data);
    });
  };

  useEffect(() => {
    updateSlider();
    app.variable.getContent("vRanking", (reply) => {
      const data = parseInt(reply.qContent.qString, 10);
      if (data !== undefined) {
        setVRanking(data);
      }
    });

    if (app) {
      initializeField();
    }
  }, [app]);

  useEffect(() => {
    setSwitchOnDemand(false);
  });

  return (
    <div className="app dashboard">
      <div className="appContent">
        {modalOpened && (
          <Modal
            title={container[7].cards[selectedButtonIndex].title.hardTitle}
            show={modalOpened}
            setShow={() => closeModal()}
            closeButton
          >
            <Card
              exportTable
              exportTableId={
                container[7].cards[selectedButtonIndex].nativeObject.id
              }
              app={app}
              style={{ width: "100%", height: "100%" }}
            >
              <NativeObject
                app={app}
                reference={{
                  id: container[7].cards[selectedButtonIndex].nativeObject.id,
                }}
              />
            </Card>
          </Modal>
        )}

        <LayoutCardsWrapper>
          {/* Visões */}
          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              height: "16%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Card
              header={{
                tooltip: container[5].cards[0].title.tooltip,
                hardTitle: container[5].cards[0].title.hardTitle,
              }}
              style={{ width: "100%" }}
            >
              <NativeObject
                app={app}
                key={{ id: container[5].cards[0].nativeObject.valueId }}
                reference={{ id: container[5].cards[0].nativeObject.id }}
                style={{
                  width: "100%",
                  height: "100%",
                  color: "4B81D0",
                  marginTop: "12px",
                }}
              />
            </Card>
          </CardWrapper>

          {/* Curva ABC */}
          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              height: "50%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                paddingRight: "0px",
                width: "70%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {/* Grafico */}
              <Card
                header={{
                  tooltip: container[6].cards[0].title.tooltip,
                  hardTitle: container[6].cards[0].title.hardTitle,
                  hardSubtitle: container[6].cards[0].subtitle.hardSubtitle,
                }}
                expandable
                exportTable
                exportContainer
                exportTableId={container[6].cards[0].nativeObject.id}
                app={app}
                style={{ width: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={{ id: container[6].cards[0].nativeObject.valueId }}
                  reference={{ id: container[6].cards[0].nativeObject.id }}
                  style={{
                    width: "100%",
                    height: "100%",
                    color: "4B81D0",
                  }}
                />
              </Card>
            </CardWrapper>

            {/* Botões */}
            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                paddingRight: "0px",
                width: "30%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  width: "100%",
                  height: "50%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* Preservar */}
                <Card style={{ width: "100%" }}>
                  <button
                    onClick={() => showModal(19)}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[0].nativeObject.valueId }}
                      reference={{ id: container[7].cards[0].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </button>
                  <NativeObject
                    app={app}
                    key={{ id: container[7].cards[1].nativeObject.valueId }}
                    reference={{ id: container[7].cards[1].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[2].nativeObject.valueId }}
                      reference={{ id: container[7].cards[2].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[3].nativeObject.valueId }}
                      reference={{ id: container[7].cards[3].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </div>
                  {/* <NativeObject
                    app={app}
                    key={{ id: container[7].cards[4].nativeObject.valueId }}
                    reference={{ id: container[7].cards[4].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: '4B81D0'
                    }}
                  /> */}
                </Card>

                {/* Elevar */}
                <Card style={{ width: "100%" }}>
                  <button
                    onClick={() => showModal(20)}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[5].nativeObject.valueId }}
                      reference={{ id: container[7].cards[5].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </button>

                  <NativeObject
                    app={app}
                    key={{ id: container[7].cards[6].nativeObject.valueId }}
                    reference={{ id: container[7].cards[6].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[7].nativeObject.valueId }}
                      reference={{ id: container[7].cards[7].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[8].nativeObject.valueId }}
                      reference={{ id: container[7].cards[8].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </div>
                  {/* <NativeObject
                    app={app}
                    key={{ id: container[7].cards[9].nativeObject.valueId }}
                    reference={{ id: container[7].cards[9].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: '4B81D0'
                    }}
                  /> */}
                </Card>
              </CardWrapper>

              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  width: "100%",
                  height: "50%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* Atacar */}
                <Card style={{ width: "100%" }}>
                  <button
                    onClick={() => showModal(21)}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[10].nativeObject.valueId }}
                      reference={{ id: container[7].cards[10].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </button>

                  <NativeObject
                    app={app}
                    key={{ id: container[7].cards[11].nativeObject.valueId }}
                    reference={{ id: container[7].cards[11].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: "4B81D0",
                    }}
                  />
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[12].nativeObject.valueId }}
                      reference={{ id: container[7].cards[12].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[13].nativeObject.valueId }}
                      reference={{ id: container[7].cards[13].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </div>
                  {/* <NativeObject
                    app={app}
                    key={{ id: container[7].cards[14].nativeObject.valueId }}
                    reference={{ id: container[7].cards[14].nativeObject.id }}
                    style={{
                      width: "100%",
                      height: "100%",
                      color: '4B81D0'
                    }}
                  /> */}
                </Card>

                {/* Todas as Curvas */}
                <Card style={{ width: "100%" }}>
                  <button
                    onClick={() => showModal(22)}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      outline: "none",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[15].nativeObject.valueId }}
                      reference={{ id: container[7].cards[15].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </button>

                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[16].nativeObject.valueId }}
                      reference={{ id: container[7].cards[16].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                    <NativeObject
                      app={app}
                      key={{ id: container[7].cards[17].nativeObject.valueId }}
                      reference={{ id: container[7].cards[17].nativeObject.id }}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "4B81D0",
                      }}
                    />
                  </div>
                </Card>
              </CardWrapper>
              <CardWrapper
                customStyle={{
                  paddingBottom: "0px",
                  paddingRight: "0px",
                  width: "100%",
                  height: "50%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* Slider */}
                <Card
                  header={{ hardTitle: container[7].cards[18].title.hardTitle }}
                  style={{ width: "100%" }}
                >
                  <Slider
                    aria-label="Always visible"
                    defaultValue={vRanking}
                    getAriaValueText={valuetext}
                    onChangeCommitted={handleSliderChangeCommitted}
                    step={1}
                    max={25}
                    min={3}
                    marks={marks}
                    valueLabelDisplay="auto"
                    style={{ marginTop: "15px" }}
                  />
                </Card>
              </CardWrapper>
            </CardWrapper>
          </CardWrapper>

          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              height: "35%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {/* TOP */}
            <div
              style={{
                width: "50%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Card
                header={{
                  tooltip: container[4].cards[0].title.tooltip,
                  hardTitle: container[4].cards[0].title.hardTitle,
                }}
                expandable
                exportTable
                exportTableId={container[4].cards[0].nativeObject.id}
                app={app}
                style={{ width: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={{ id: container[4].cards[0].nativeObject.valueId }}
                  reference={{ id: container[4].cards[0].nativeObject.id }}
                  style={{
                    width: "100%",
                    height: "100%",
                    color: "4B81D0",
                  }}
                />
              </Card>
            </div>

            {/* BOTTOM */}
            <div
              style={{
                width: "50%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Card
                header={{
                  tooltip: container[4].cards[1].title.tooltip,
                  hardTitle: container[4].cards[1].title.hardTitle,
                }}
                expandable
                exportTable
                exportTableId={container[4].cards[1].nativeObject.id}
                app={app}
                style={{ width: "100%" }}
              >
                <NativeObject
                  app={app}
                  reference={{ id: container[4].cards[1].nativeObject.id }}
                  style={{
                    width: "100%",
                    height: "100%",
                    color: "4B81D0",
                  }}
                />
              </Card>
            </div>
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DashboardDesktop.defaultProps = {
  app: null,
  config: {},
};

DashboardDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DashboardDesktop;
